<template>
  <div class="info-section bg-white-blue print-no-overlap">
    <ScreenWidthProvider
      v-slot="{ isWider, isNarrower }"
      class="flex flex-col md:flex-row"
    >
      <div
        v-if="hasIcon && (isWider('md') || (isNarrower('md') && mobileTitle))"
        class="info-section-icon flex flex-row justify-center grow print-hidden"
        :class="variants[variant]?.icon"
      >
        <fa
          v-if="icon"
          :icon="icon"
        />
        <slot name="icon" />
        <h5 class="block md:hidden ml-2 pl-1 mb-0">
          <span
            v-if="mobileTitleKey"
            :data-i18n="mobileTitleKey"
          >{{ mobileTitle }}</span>
          <span v-else>
            {{ mobileTitle }}
          </span>
        </h5>
      </div>
      <div
        class="py-6 flex items-center mx-print-0 px-print-0 py-print-0"
        :class="variants[variant]?.text"
      >
        <div class="block">
          <h5
            v-if="title"
            class="mb-1"
          >
            <span
              v-if="titleKey"
              :data-i18n="titleKey"
            >{{ title }}</span>
            <span v-else>
              {{ title }}
            </span>
          </h5>
          <p
            v-if="text && !textTranslationKey"
            class="mb-0"
            :data-i18n="textKey"
            v-html="text"
          />
          <p
            v-else
            class="mb-0"
            :data-translation="textTranslationKey"
            v-html="text"
          />
          <slot />
        </div>
      </div>
    </ScreenWidthProvider>
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    title: {
      type: String,
      default: '',
    },

    titleKey: {
      type: String,
      default: '',
    },

    text: {
      type: String,
      default: '',
    },

    textKey: {
      type: String,
      default: '',
    },

    textTranslationKey: {
      type: String,
      default: '',
    },

    icon: {
      type: [String, Object],
      default: null,
    },

    mobileTitle: {
      type: String,
      default: '',
    },

    mobileTitleKey: {
      type: String,
      default: '',
    },

    variant: {
      type: String,
      default: 'color',
      validator: value => ['color', 'background'].includes(value),
    },
  },

  data () {
    return {
      variants: {
        background: {
          icon: 'info-section-icon-variant-background px-6 py-4 md:py-4 text-white bg-medium-blue items-center',
          text: 'px-2 md:px-4 mx-4',
        },

        color: {
          icon: 'info-section-icon-variant-color py-4 md:py-4 text-medium-blue items-center md:items-start',
          text: 'pl-2 md:pl-0 ml-4 md:ml-0 pr-2 md:pr-4 mr-4',
        },
      },
    }
  },

  computed: {
    hasIcon () {
      return this.icon !== undefined || this.$slots.icon
    },
  },
})
</script>

<style lang="scss">
.info-section {
  &-icon {
    &-variant {
      &-background {
        min-width: 100px;
        max-width: 100px;
      }

      &-color {
        min-width: 120px;
        max-width: 120px;

        @media (min-width: theme('screens.md')) {
          svg {
            padding-left: 2rem;
            padding-right: 2rem;
          }
        }
      }
    }

    h5 {
      font-size: 1.25rem;
    }

    svg {
      height: auto;
      width: 100%;

      @media (max-width: calc(theme('screens.md') - 1px)) {
        width: unset;
      }
    }

    @media (max-width: calc(theme('screens.md') - 1px)) {
      background: theme('colors.medium-blue');
      color: white !important;
      min-width: 100%;

      svg {
        width: unset;
        max-height: 25px;
      }
    }
  }
}
</style>
